var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import Input from '../../../input';
import TextArea from '../../../text-area';
import { useField, useFormikContext } from 'formik';
import FormInput from '../form-input';
import { useFormField } from '../../hooks';
import { useErrorTrackingOnSubmit, useHandleBlur } from '../hooks';
import theme from '../../../../theme';
var TextInput = function (_a) {
    var label = _a.label, subtext = _a.subtext, tooltip = _a.tooltip, headingChildren = _a.headingChildren, dataTestId = _a.dataTestId, trackValidationOnBlur = _a.trackValidationOnBlur, trackValidationOnSubmit = _a.trackValidationOnSubmit, _b = _a.isTextArea, isTextArea = _b === void 0 ? false : _b, restProps = __rest(_a, ["label", "subtext", "tooltip", "headingChildren", "dataTestId", "trackValidationOnBlur", "trackValidationOnSubmit", "isTextArea"]);
    var field = useField(restProps)[0];
    var validateOnBlur = useFormikContext().validateOnBlur;
    var _c = useFormField(field.name), error = _c.error, customError = _c.customError, customWarning = _c.customWarning, touched = _c.touched, validateField = _c.validateField;
    var onBlur = field.onBlur, name = field.name;
    var _handleBlur = useHandleBlur(onBlur, name, validateField, validateOnBlur, trackValidationOnBlur);
    useErrorTrackingOnSubmit(name, trackValidationOnSubmit);
    var sharedProps = __assign(__assign(__assign({}, field), restProps), { error: error || customError, warning: customWarning, touched: touched, padding: theme.spacing.small, onBlur: _handleBlur, 'data-testid': dataTestId });
    return (React.createElement(FormInput, { label: label, subtext: subtext, tooltip: tooltip, name: name, error: error || customError, warning: customWarning, touched: touched, headingChildren: headingChildren }, isTextArea ? (React.createElement(TextArea, __assign({}, sharedProps))) : (React.createElement(Input, __assign({ type: "text" }, sharedProps)))));
};
export default memo(TextInput);
